import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import config from './config'

Vue.use(Vueaxios, axios)
export default {
  selectSettingRice (header, success, error) {
    Vue.axios.get(config.baseURLV2 + '/api/settingrice').then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  saveRiceSummery (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/ricesummery/save', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  decreaseRemain (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/remainstock/decrease', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  insertWaitingTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/insertwaitingtransfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/selecttranfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  selectOutTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/selectouttranfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  cancelTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/canceltransfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  approveOutTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/approveouttransfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  approveInTransferStock (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/approveintransfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  notificationTransfer (body, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/notificationtransfer', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  changeActivity (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/changeactivity', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  confirmActivity (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/transferstock/pos/confirmActivity', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  updateStock (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/pos/updateStock', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  resetStockEgg (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/stock/resetstockegg', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getProductEgg (header, success, error) {
    Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductEgg').then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getProductRiceMar (header, success, error) {
    Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductRiceMar' + header).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getProductEggSummarySale (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/confirmsale/getProductEggSummarySale', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  getProductRiceMarSummarySale (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/confirmsale/getProductRiceMarSummarySale', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  saveConfirmSaleEgg (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/confirmsale/saveConfirmSaleEgg', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  saveConfirmSaleRiceMar (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/confirmsale/saveConfirmSaleRiceMar', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  deleteSaleRiceMar (body, header, success, error) {
    Vue.axios.post(config.baseURLV2 + '/api/confirmsale/deleteSaleRiceMar', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  }
  // getProductEggSummarySale (header, success, error) {
  //   Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductEggSummarySale').then(
  //     response => {
  //       success(response)
  //     },
  //     response => {
  //       error(response)
  //     }
  //   )
  // },
  // getProductRiceMarSummarySale (header, success, error) {
  //   Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductRiceMarSummarySale').then(
  //     response => {
  //       success(response)
  //     },
  //     response => {
  //       error(response)
  //     }
  //   )
  // }
}



// WEBPACK FOOTER //
// ./src/services/service_undefined_v2.js